import { useEffect, useMemo, useRef, useState } from "react";
import Swal from "sweetalert2";
import {
  swalSuccess,
  swalError,
  swalConfirm,
} from "../../../utils/swalAlert.js";
import {
  getAdminStores,
  changeAdminStoreStatus,
  changeAdminStoreSubscription,
  changeAdminStoreSupport,
  deleteAdminStore,
} from "../../../api/admin/storeManagement";
import "../../../styles/AdminPanel/StoreManagementList.css";

import { getUsers } from "../../../api/admin/userManager.js";
import moment from "jalali-moment";
import { convertToPersianDigits } from "../../../utils/stringUtil.js";
const PAGE_SIZE = 8;

const IconSearch = ({ size = 18, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const IconRefresh = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

const IconExternalLink = ({ size = 13, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

const IconEdit = ({ size = 11, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const IconUserPlus = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <line x1="19" y1="8" x2="19" y2="14" />
    <line x1="16" y1="11" x2="22" y2="11" />
  </svg>
);

const IconClose = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const IconChevronDown = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const IconTrash = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

/* آیکون‌های جدید برای وضعیت (تعلیق / فعال‌سازی) و لودینگ */
const IconPauseCircle = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="10" y1="15" x2="10" y2="9" />
    <line x1="14" y1="15" x2="14" y2="9" />
  </svg>
);

const IconCheckCircle = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const IconSpinner = ({ size = 16, className }) => (
  <svg
    className={`spin-animate ${className || ""}`}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);

// تبدیل ارقام فارسی/عربی به انگلیسی و حذف کاراکترهای غیرعددی
const normalizeDigits = (value) =>
  String(value || "")
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 1776))
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 1632))
    .replace(/\D/g, "");

// شماره موبایل ایران: 09xxxxxxxxx
const isValidMobile = (value) => /^09\d{9}$/.test(normalizeDigits(value));

// ========================= مدال اختصاصی انتصاب پشتیبان (بدون Swal) =========================
function AssignSupportModal({
  open,
  store,
  agents,
  agentsLoading,
  submitting,
  selectedId,
  onSelectChange,
  phone,
  onPhoneChange,
  onClose,
  onConfirm,
}) {
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (!open) setTouched(false);
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape" && !submitting) onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, submitting, onClose]);

  if (!open) return null;

  const noAgentsFound = !agentsLoading && agents.length === 0;
  const showValidationError = touched && !selectedId && !noAgentsFound;
  const showPhoneError = touched && !!selectedId && !isValidMobile(phone);

  const handleConfirmClick = () => {
    setTouched(true);
    if (!selectedId || !isValidMobile(phone)) return;
    onConfirm();
  };

  return (
    <div
      className="assign-modal-overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !submitting) onClose();
      }}
    >
      <div className="assign-modal" role="dialog" aria-modal="true">
        <div className="assign-modal-header">
          <h3 className="assign-modal-title">انتصاب پشتیبان</h3>
          <button
            type="button"
            className="assign-modal-close"
            onClick={onClose}
            disabled={submitting}
            aria-label="بستن"
          >
            <IconClose size={16} />
          </button>
        </div>

        <div className="assign-modal-body">
          <p className="assign-modal-text">
            پشتیبان مسئول فروشگاه «{store?.store_name || "بدون نام"}» را انتخاب
            کنید:
          </p>

          {agentsLoading ? (
            <div className="assign-modal-loading">
              <span className="assign-modal-spinner" />
              در حال دریافت لیست پشتیبان‌ها...
            </div>
          ) : (
            <div
              className={`assign-modal-select-wrapper ${
                showValidationError ? "has-error" : ""
              }`}
            >
              <select
                className="assign-modal-select"
                value={selectedId}
                onChange={(e) => onSelectChange(e.target.value)}
                disabled={submitting || noAgentsFound}
              >
                <option value="" disabled>
                  انتخاب پشتیبان...
                </option>
                {agents.map((agent) => (
                  <option key={agent.id} value={agent.id}>
                    {agent.first_name + " " + agent.last_name}
                  </option>
                ))}
              </select>
              <IconChevronDown className="assign-modal-select-icon" size={16} />
            </div>
          )}

          {showValidationError && (
            <span className="assign-modal-error-text">
              لطفاً یک پشتیبان انتخاب کنید.
            </span>
          )}

          {selectedId && !agentsLoading && (
            <div className="assign-modal-field">
              <label className="assign-modal-label" htmlFor="assign-phone">
                شماره موبایل پشتیبان
              </label>
              <input
                id="assign-phone"
                type="tel"
                inputMode="numeric"
                dir="ltr"
                maxLength={11}
                className={`assign-modal-input ${
                  showPhoneError ? "has-error" : ""
                }`}
                placeholder="09123456789"
                value={phone}
                onChange={(e) =>
                  onPhoneChange(normalizeDigits(e.target.value).slice(0, 11))
                }
                disabled={submitting}
              />
              {showPhoneError && (
                <span className="assign-modal-error-text">
                  شماره موبایل معتبر نیست (مثال: 09123456789).
                </span>
              )}
            </div>
          )}

          {noAgentsFound && (
            <span className="assign-modal-error-text">
              هیچ پشتیبانی برای انتصاب یافت نشد.
            </span>
          )}
        </div>

        <div className="assign-modal-footer">
          <button
            type="button"
            className="modal-btn cancel"
            onClick={onClose}
            disabled={submitting}
          >
            انصراف
          </button>
          <button
            type="button"
            className="modal-btn confirm"
            onClick={handleConfirmClick}
            disabled={submitting || agentsLoading || noAgentsFound}
          >
            {submitting ? "..." : "ذخیره تغییرات"}
          </button>
        </div>
      </div>
    </div>
  );
}

// کلاس‌های سفارشی برای دیالوگ ورودی (input)
const INPUT_DIALOG_CLASSES = {
  popup: "app-swal-popup",
  title: "app-swal-title",
  htmlContainer: "app-swal-text",
  confirmButton: "app-swal-confirm",
  cancelButton: "app-swal-cancel",
};

export default function StoreManagementList() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [updatingId, setUpdatingId] = useState(null);
  const [activeTab, setActiveTab] = useState("active");
  const [sortBy, setSortBy] = useState("remaining_days");
  const [page, setPage] = useState(1);
  const [supportAgents, setSupportAgents] = useState([]);
  const [supportsLoading, setSupportsLoading] = useState(false);
  const supportAgentsFetchedRef = useRef(false);

  // مدال اختصاصی انتصاب پشتیبان
  const [assignTarget, setAssignTarget] = useState(null);
  const [selectedSupportId, setSelectedSupportId] = useState("");
  const [supportPhone, setSupportPhone] = useState("");
  const [assignSubmitting, setAssignSubmitting] = useState(false);

  // دریافت لیست فروشگاه‌ها
  const fetchStores = async (query = "", sort = "remaining_days") => {
    setLoading(true);
    try {
      const data = await getAdminStores(query, sort);
      setStores(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("خطا در دریافت لیست فروشگاه‌ها", err);
      swalError({
        title: "خطا در دریافت اطلاعات",
        text:
          err?.detail ||
          err?.error ||
          "خطا در دریافت اطلاعات. لطفا دسترسی خود را بررسی کنید.",
      });
    } finally {
      setLoading(false);
    }
  };

  // دریافت لیست پشتیبان‌ها
  const fetchSupportAgents = async () => {
    setSupportsLoading(true);
    try {
      const data = await getUsers("support");
      const list = Array.isArray(data) ? data : [];
      setSupportAgents(list);
      supportAgentsFetchedRef.current = true;
      return list;
    } catch (err) {
      console.error("خطا در دریافت لیست پشتیبان‌ها", err);
      swalError({
        title: "خطا در دریافت اطلاعات",
        text:
          err?.detail ||
          err?.error ||
          "خطا در دریافت لیست پشتیبان‌ها. لطفا دسترسی خود را بررسی کنید.",
      });
      return null;
    } finally {
      setSupportsLoading(false);
    }
  };

  useEffect(() => {
    fetchStores(searchQuery, sortBy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isFirstStoreSearchRun = useRef(true);
  useEffect(() => {
    if (isFirstStoreSearchRun.current) {
      isFirstStoreSearchRun.current = false;
      return;
    }
    fetchStores(searchQuery, sortBy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, sortBy]);

  useEffect(() => {
    setPage(1);
  }, [activeTab, searchQuery, sortBy]);

  // تغییر وضعیت تعلیق / فعال‌سازی
  const handleStatusChange = async (storeId, currentStatus) => {
    const nextStatus = currentStatus === "active" ? "suspended" : "active";

    const confirmText =
      nextStatus === "active"
        ? "آیا از فعال‌سازی این فروشگاه مطمئن هستید؟"
        : "آیا از تعلیق / غیرفعال‌سازی این فروشگاه مطمئن هستید؟";

    const ok = await swalConfirm({
      title: "تغییر وضعیت فروشگاه",
      text: confirmText,
      confirmText: nextStatus === "active" ? "فعال‌سازی" : "تعلیق",
      cancelText: "انصراف",
      danger: nextStatus !== "active",
    });

    if (!ok) return;

    setUpdatingId(storeId);

    try {
      await changeAdminStoreStatus(storeId, {
        status: nextStatus,
      });

      setStores((prev) =>
        prev.map((store) =>
          store.store_id === storeId ? { ...store, status: nextStatus } : store,
        ),
      );

      swalSuccess({
        title: "انجام شد",
        text:
          nextStatus === "active"
            ? "فروشگاه با موفقیت فعال شد."
            : "فروشگاه با موفقیت تعلیق شد.",
      });
    } catch (err) {
      console.error("خطا در تغییر وضعیت فروشگاه", err);
      swalError({
        text: err?.detail || err?.error || "تغییر وضعیت فروشگاه ناموفق بود.",
      });
    } finally {
      setUpdatingId(null);
    }
  };

  // حذف فروشگاه
  const handleDeleteStore = async (store) => {
    const ok = await swalConfirm({
      title: "حذف فروشگاه",
      text: `آیا از حذف فروشگاه «${store.store_name || "بدون نام"}» مطمئن هستید؟ این عمل قابل بازگشت نیست.`,
      confirmText: "حذف",
      cancelText: "انصراف",
      danger: true,
    });

    if (!ok) return;

    setUpdatingId(store.store_id);

    try {
      await deleteAdminStore(store.store_id);

      setStores((prev) => prev.filter((s) => s.store_id !== store.store_id));

      swalSuccess({
        title: "انجام شد",
        text: "فروشگاه با موفقیت حذف شد.",
      });
    } catch (err) {
      console.error("خطا در حذف فروشگاه", err);
      swalError({
        text: err?.detail || err?.error || "حذف فروشگاه ناموفق بود.",
      });
    } finally {
      setUpdatingId(null);
    }
  };

  // ویرایش روزهای باقی‌مانده
  const handleEditRemainingDays = async (store) => {
    const result = await Swal.fire({
      title: "ویرایش روزهای باقی‌مانده",
      text: `روزهای باقی‌مانده اشتراک فروشگاه «${store.store_name || "بدون نام"}» را مشخص کنید:`,
      input: "number",
      inputValue: store.remaining_days ?? 0,
      inputAttributes: {
        min: 0,
        step: 1,
      },
      showCancelButton: true,
      confirmButtonText: "ذخیره تغییرات",
      cancelButtonText: "انصراف",
      buttonsStyling: false,
      reverseButtons: true,
      width: 320,
      customClass: INPUT_DIALOG_CLASSES,
      inputValidator: (value) => {
        if (value === "" || value === null) {
          return "لطفاً تعداد روز را وارد کنید.";
        }
        const num = Number(value);
        if (!Number.isInteger(num) || num < 0) {
          return "تعداد روزها باید یک عدد صحیح بزرگ‌تر یا مساوی صفر باشد.";
        }
        return undefined;
      },
    });

    if (!result.isConfirmed) return;

    const newDays = Number(result.value);

    try {
      await changeAdminStoreSubscription(store.store_id, {
        remaining_days: newDays,
      });

      swalSuccess({
        title: "موفقیت‌آمیز",
        text: "روزهای باقی‌مانده اشتراک با موفقیت ویرایش شد.",
      });

      fetchStores(searchQuery, sortBy);
    } catch (error) {
      console.error("خطا در تغییر روزهای باقی‌مانده", error);
      swalError({
        text: error.detail || error.error || "خطا در تغییر روزهای باقی‌مانده",
      });
    }
  };

  // انتصاب / تغییر پشتیبان
  const handleAssignSupport = (store) => {
    setAssignTarget(store);
    setSelectedSupportId(
      store.support_id !== null && store.support_id !== undefined
        ? String(store.support_id)
        : "",
    );
    setSupportPhone(normalizeDigits(store.support_phone));

    if (!supportAgentsFetchedRef.current && !supportsLoading) {
      fetchSupportAgents();
    }
  };

  const closeAssignModal = () => {
    if (assignSubmitting) return;
    setAssignTarget(null);
    setSelectedSupportId("");
    setSupportPhone("");
  };

  const handleConfirmAssign = async () => {
    if (!assignTarget || !selectedSupportId || !isValidMobile(supportPhone))
      return;

    const store = assignTarget;
    const newSupportId = selectedSupportId;
    const selectedAgent = supportAgents.find(
      (agent) => String(agent.id) === String(newSupportId),
    );

    setAssignSubmitting(true);

    try {
      await changeAdminStoreSupport(store.store_id, {
        assigned_to: Number(newSupportId),
        assigned_mobile: normalizeDigits(supportPhone),
      });

      setStores((prev) =>
        prev.map((s) =>
          s.store_id === store.store_id
            ? {
                ...s,
                support_id: newSupportId,
                support_phone: normalizeDigits(supportPhone),
                support_name: selectedAgent?.assigned_to
                  ? `${selectedAgent.assigned_to.first_name} ${selectedAgent.assigned_to.last_name}`
                  : s.support_name,
              }
            : s,
        ),
      );

      swalSuccess({
        title: "انجام شد",
        text: "پشتیبان فروشگاه با موفقیت ثبت شد.",
      });
      setAssignTarget(null);
      setSelectedSupportId("");
      setSupportPhone("");
    } catch (error) {
      console.error("خطا در انتصاب پشتیبان", error);
      swalError({
        text: error?.detail || error?.error || "انتصاب پشتیبان ناموفق بود.",
      });
    } finally {
      setAssignSubmitting(false);
    }
  };

  const isExpiredStore = (store) => {
    const days = store.remaining_days;
    return days !== null && days !== undefined && days <= 0;
  };

  const SORT_OPTIONS = [
    { value: "newest", label: "جدیدترین فروشگاه" },
    { value: "oldest", label: "قدیمی‌ترین فروشگاه" },
    { value: "most_visits", label: "بیشترین بازدید سایت" },
    { value: "least_visits", label: "کمترین بازدید سایت" },
    { value: "least_remaining_days", label: "کمترین روزهای باقی‌مانده" },
    { value: "most_remaining_days", label: "بیشترین روزهای باقی‌مانده" },
  ];

  const { activeStores, expiredStores } = useMemo(() => {
    const active = [];
    const expired = [];

    for (const store of stores) {
      if (isExpiredStore(store)) {
        expired.push(store);
      } else {
        active.push(store);
      }
    }

    return { activeStores: active, expiredStores: expired };
  }, [stores]);

  const displayedStores =
    activeTab === "expired" ? expiredStores : activeStores;

  const totalCount = displayedStores.length;
  const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));
  const pageSafe = Math.min(page, totalPages);

  useEffect(() => {
    if (page !== pageSafe) setPage(pageSafe);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalCount]);

  const pageNumbers = useMemo(() => {
    const nums = [];
    for (let n = 1; n <= totalPages; n++) nums.push(n);
    return nums;
  }, [totalPages]);

  const pagedStores = useMemo(() => {
    const start = (pageSafe - 1) * PAGE_SIZE;
    return displayedStores.slice(start, start + PAGE_SIZE);
  }, [displayedStores, pageSafe]);

  const getRemainingDaysBadge = (store) => {
    const days = store.remaining_days;
    let badgeClass = "days-badge--ok";
    let text = days;

    if (days === null || days === undefined) {
      badgeClass = "days-badge--unknown";
      text = "—";
    } else if (days <= 0) {
      badgeClass = "days-badge--expired";
      text = "۰";
    } else if (days <= 10) {
      badgeClass = "days-badge--warn";
    }

    return (
      <div
        className="remaining-days-interactive"
        onClick={() => handleEditRemainingDays(store)}
        title="جهت ویرایش دستی روزهای باقی‌مانده کلیک کنید"
      >
        <span className={`days-badge ${badgeClass}`}>{text}</span>
        <IconEdit className="edit-inline-icon" size={11} />
      </div>
    );
  };

  const renderStatusLabel = (status) => {
    if (status === "active") {
      return <span className="status-label status-label--active">فعال</span>;
    }
    if (status === "suspended") {
      return <span className="status-label status-label--suspended">معلق</span>;
    }
    return (
      <span className="status-label status-label--pending">در انتظار</span>
    );
  };

  const planText = (store) => store.plan_name || "بدون پلن";

  const supportText = (store) =>
    store.assigned_to
      ? `${store.assigned_to.first_name} ${store.assigned_to.last_name}`
      : "بدون پشتیبان";

  const supportPhoneText = (store) => store.assigned_mobile || "";

  // کامپوننت مشترک دکمه‌های عملیات مدرن آیکونی
  const renderActions = (store) => {
    const isUpdating = updatingId === store.store_id;
    const isActive = store.status === "active";

    return (
      <div className="actions-group-modern">
        {/* دکمه تغییر وضعیت: فعال‌سازی / تعلیق */}
        <button
          type="button"
          disabled={isUpdating}
          onClick={() => handleStatusChange(store.store_id, store.status)}
          className={`action-icon-btn ${isActive ? "btn-suspend" : "btn-activate"}`}
          title={isActive ? "تعلیق فروشگاه" : "فعال‌سازی فروشگاه"}
          aria-label={isActive ? "تعلیق فروشگاه" : "فعال‌سازی فروشگاه"}
        >
          {isUpdating ? (
            <IconSpinner size={16} />
          ) : isActive ? (
            <IconPauseCircle size={16} />
          ) : (
            <IconCheckCircle size={16} />
          )}
        </button>

        {/* دکمه انتصاب پشتیبان */}
        <button
          type="button"
          disabled={isUpdating}
          onClick={() => handleAssignSupport(store)}
          className="action-icon-btn btn-assign"
          title="انتصاب پشتیبان"
          aria-label="انتصاب پشتیبان"
        >
          <IconUserPlus size={16} />
        </button>

        {/* دکمه حذف فروشگاه */}
        <button
          type="button"
          disabled={isUpdating}
          onClick={() => handleDeleteStore(store)}
          className="action-icon-btn btn-delete"
          title="حذف فروشگاه"
          aria-label="حذف فروشگاه"
        >
          <IconTrash size={16} />
        </button>
      </div>
    );
  };

  const Pagination = () =>
    totalCount > 0 && (
      <div className="orders-pagination">
        <span className="pagination-info">
          {totalCount.toLocaleString("fa-IR")} فروشگاه — صفحه{" "}
          {pageSafe.toLocaleString("fa-IR")} از{" "}
          {totalPages.toLocaleString("fa-IR")}
        </span>
        <div className="pagination-controls">
          <button
            className="page-btn"
            disabled={pageSafe === 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            aria-label="صفحه قبل"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M15 6l-6 6 6 6" />
            </svg>
          </button>
          {pageNumbers.map((n) => (
            <button
              key={n}
              className={`page-btn number${n === pageSafe ? " active" : ""}`}
              onClick={() => setPage(n)}
            >
              {n.toLocaleString("fa-IR")}
            </button>
          ))}
          <button
            className="page-btn"
            disabled={pageSafe === totalPages}
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            aria-label="صفحه بعد"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 6l6 6-6 6" />
            </svg>
          </button>
        </div>
      </div>
    );

  return (
    <div className="store-mgmt-page">
      <div className="store-mgmt-header">
        <h2 className="store-mgmt-title">مدیریت وضعیت فروشگاه‌ها</h2>
      </div>

      <div className="store-mgmt-controls">
        <div className="search-wrapper">
          <input
            type="text"
            placeholder="جستجو بر اساس نام فروشگاه و نام پشتیبان"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <IconSearch className="search-icon" size={18} />
        </div>

        <div className="sort-select-wrapper">
          <select
            className="sort-select"
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            aria-label="چیدمان بر اساس"
          >
            {SORT_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <IconChevronDown className="sort-select-icon" size={16} />
        </div>
      </div>

      {/* سیستم تب‌بندی */}
      <div className="store-mgmt-tabs" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "active"}
          className={`store-mgmt-tab ${activeTab === "active" ? "is-active" : ""}`}
          onClick={() => setActiveTab("active")}
        >
          در حال اشتراک
          <span className="store-mgmt-tab-count">{activeStores.length}</span>
        </button>

        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "expired"}
          className={`store-mgmt-tab ${activeTab === "expired" ? "is-active" : ""}`}
          onClick={() => setActiveTab("expired")}
        >
          پایان اشتراک
          <span className="store-mgmt-tab-count">{expiredStores.length}</span>
        </button>
      </div>

      {loading ? (
        <div className="loading-indicator">در حال بارگذاری...</div>
      ) : (
        <>
          <div className="table-wrapper desktop-only">
            <table className="stores-table">
              <thead>
                <tr>
                  <th className="col-name">فروشگاه</th>
                  <th className="col-name">شماره مالک فروشگاه</th>
                  <th className="col-slug">آدرس سایت</th>
                  <th className="col-plan">پلن</th>
                  <th className="col-support">پشتیبان</th>
                  <th className="col-support">شماره پشتیبان</th>
                  <th className="col-support">بازدید سایت</th>
                  <th className="col-days">باقی‌مانده</th>
                  <th className="col-days">تاریخ پایان اشتراک</th>
                  <th className="col-status">وضعیت</th>
                  <th className="col-actions">عملیات</th>
                </tr>
              </thead>
              <tbody>
                {pagedStores.map((store) => (
                  <tr key={store.store_id}>
                    <td className="cell-name" title={store.store_name || ""}>
                      {store.store_name || "—"}
                    </td>
                    <td className="cell-name" title={store.mobile || ""}>
                      {store.mobile || "—"}
                    </td>

                    <td className="cell-slug">
                      <a
                        href={`/${store.store_slug}`}
                        target="_blank"
                        rel="noreferrer"
                        className="store-link"
                        title={store.store_slug || ""}
                      >
                        <span className="slug-text">
                          {store.store_slug || "—"}
                        </span>
                        <IconExternalLink size={13} />
                      </a>
                    </td>

                    <td className="cell-plan">
                      <span className="plan-ellipsis" title={planText(store)}>
                        {planText(store)}
                      </span>
                    </td>

                    <td className="cell-support">
                      <span
                        className="support-ellipsis"
                        title={supportText(store)}
                      >
                        {supportText(store)}
                      </span>
                    </td>
                    <td
                      className="cell-support"
                      title={supportPhoneText(store)}
                    >
                      {supportPhoneText(store) || "—"}
                    </td>
                    <td className="cell-days">{store.visit ?? 0}</td>
                    <td className="cell-days">
                      {getRemainingDaysBadge(store)}
                    </td>
                    <td className="cell-days">
                      {convertToPersianDigits(
                        moment(store.end_date).format("HH:mm - jYYYY/jMM/jDD"),
                      )}
                    </td>
                    <td className="cell-status">
                      {renderStatusLabel(store.status)}
                    </td>

                    <td className="cell-actions">{renderActions(store)}</td>
                  </tr>
                ))}

                {pagedStores.length === 0 && (
                  <tr>
                    <td colSpan={11} className="no-data-msg">
                      {activeTab === "expired"
                        ? "فروشگاهی با اشتراک تمام‌شده یافت نشد."
                        : "فروشگاهی یافت نشد."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <Pagination />
          </div>

          <div className="mobile-cards-wrapper">
            {pagedStores.map((store) => (
              <div className="store-mobile-card" key={store.store_id}>
                <div className="card-title-row">
                  <span
                    className="card-store-name"
                    title={store.store_name || ""}
                  >
                    {store.store_name || "—"}
                  </span>

                  <a
                    href={`/${store.store_slug}`}
                    target="_blank"
                    rel="noreferrer"
                    className="store-link store-link--compact"
                  >
                    {store.store_slug || "—"} <IconExternalLink size={13} />
                  </a>
                </div>

                <div className="card-rows">
                  <div className="card-row">
                    <span className="lbl">شماره مالک</span>
                    <span className="val val--phone" title={store.mobile || ""}>
                      {store.mobile ? (
                        <a href={`tel:${store.mobile}`} className="phone-link">
                          {store.mobile}
                        </a>
                      ) : (
                        "—"
                      )}
                    </span>
                  </div>

                  <div className="card-row">
                    <span className="lbl">پلن</span>
                    <span className="val plan-ellipsis" title={planText(store)}>
                      {planText(store)}
                    </span>
                  </div>

                  <div className="card-row">
                    <span className="lbl">پشتیبان</span>
                    <span
                      className="val support-ellipsis"
                      title={supportText(store)}
                    >
                      {supportText(store)}
                    </span>
                  </div>

                  <div className="card-row">
                    <span className="lbl">شماره پشتیبان</span>
                    <span
                      className="val val--phone"
                      title={supportPhoneText(store)}
                    >
                      {supportPhoneText(store) || "—"}
                    </span>
                  </div>

                  <div className="card-row">
                    <span className="lbl">بازدید سایت</span>
                    <span className="val">{store.visit ?? 0}</span>
                  </div>

                  <div className="card-row">
                    <span className="lbl">باقی‌مانده</span>
                    <span className="val">{getRemainingDaysBadge(store)}</span>
                  </div>
                  <div className="card-row">
                    <span className="lbl">تاریخ پایان اشتراک</span>
                    <span className="val">
                      {convertToPersianDigits(
                        moment(store.end_date).format("HH:mm - jYYYY/jMM/jDD"),
                      )}
                    </span>
                  </div>

                  <div className="card-row">
                    <span className="lbl">وضعیت</span>
                    <span className="val">
                      {renderStatusLabel(store.status)}
                    </span>
                  </div>
                </div>

                <div className="card-footer">{renderActions(store)}</div>
              </div>
            ))}

            {pagedStores.length === 0 && (
              <div className="no-data-msg">
                {activeTab === "expired"
                  ? "فروشگاهی با اشتراک تمام‌شده یافت نشد."
                  : "فروشگاهی یافت نشد."}
              </div>
            )}

            <Pagination />
          </div>
        </>
      )}

      <AssignSupportModal
        open={!!assignTarget}
        store={assignTarget}
        agents={supportAgents}
        agentsLoading={supportsLoading}
        submitting={assignSubmitting}
        selectedId={selectedSupportId}
        onSelectChange={setSelectedSupportId}
        phone={supportPhone}
        onPhoneChange={setSupportPhone}
        onClose={closeAssignModal}
        onConfirm={handleConfirmAssign}
      />
    </div>
  );
}
